<template>
  <div :class="$style.root">
    <p :class="$style.message">
      {{ $t('shared.localeUnavailable.message', { title, locale: $t(`language.${activeCode}`) }) }}
    </p>

    <i18nLink
      :to="to"
      :locale="defaultCode"
      :class="$style.link"
    >
      {{ $t('shared.localeUnavailable.link', { locale: $t(`language.${defaultCode}`) }) }}
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  slug: string
  title?: string
}>()

const nuxtApp = useNuxtApp()
const route = useRoute()
const { locale, defaultLocale } = useI18n()

const activeCode = locale
const defaultCode = defaultLocale

// The entry only exists in the default locale, so link to that version of the
// current route. Query params are filtered for the same reason link components
// filter them — see utils/route/filter-query.ts.
const to = computed(() => ({
  name: nuxtApp.$getRouteBaseName(),
  params: { slug: props.slug },
  query: filterRouteQuery(route?.query)
}))
</script>

<style module>
.root {
  composes: container font-size-large from global;

  margin-block: var(--unit--vertical);

  padding: var(--unit--default);
  text-align: center;

  background-color: var(--color--primary);
  color: var(--color--background);
}

.message {
  margin: 0;
}

.link {
  composes: reset-link link from global;
}
</style>
